function extractOrganizationIdFromCookie(cookie = '') {
  const organizationValue = cookie.split(';').find(q => q.match(/organization/));
  return organizationValue ? organizationValue.split('=')[1] : undefined;
}

export default function getCurrentOrganizationId(src = window) {
  const organizationParam = src.location.search.substring(1)
    .split('&')
    .find(q => q.match(/organization/));
  const organizationCookie = extractOrganizationIdFromCookie(src.document.cookie);
  if (organizationParam) {
    return organizationParam.split('=')[1];
  } else if (organizationCookie) {
    return organizationCookie;
  }
  return src.document.getElementById('LoisRoot').dataset.organization;
}

export function getDefaultOrganizationId(src = window) {
  return src.document.getElementById('LoisRoot').dataset.organization;
}



// WEBPACK FOOTER //
// ./src/utils/getCurrentOrganizationId.js